import html2canvas from 'html2canvas'
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcodejs2'

const registerMixin = {
    data() {
        return {
            loadingVipStart: false,
        }
    },
    methods: {
        // 卡片开始下载
        startDownLoad(downName='card-download', refName='vidCardBlock') {
            this.loadingVipStart = true
            const el = this.$refs[refName]
            html2canvas(el, {
                width: el.offsetWidth,
                height: el.offsetHeight,
                useCORS: true,
                logging: true,
                scrollY: 0,
                scrollX: 0,
                imageTimeout: 30000
            }).then(canvas => {
                let url=canvas.toDataURL("image/jpeg")
                const a = document.createElement('a')
                a.href = url
                a.setAttribute('download', downName)
                a.click()
                this.loadingVipStart = false
            }).catch(() => {
                this.loadingVipStart = false
            })
        },
        //生成二维码
        createQRCode(data,id){
            this.$nextTick(() => {
                document.getElementById(id).innerHTML = "";
                new QRCode(id, {
                   width: 130,
                   height: 130,
                   text: data,    //二维码链接
                   colorDark: "#333",  //二维码颜色
                   colorLight: '#fff',    //二维码背景色
                   correctLevel: QRCode.CorrectLevel.L   //容错率    L/M/H
                })
            })
         },
        // 生成条码
        createJsbarcode(n, color="#eee", id='#barcode') {
            let params = {
                height: 40,
                format: "CODE128C",
                displayValue: true, // 是否在条形码下方显示文字
                margin: 0,
                fontSize: 13
            }
            if (color) {
                params.background = color
            }
            this.$nextTick(() => {
                // 如果是CODE128C n需要偶数位
                JsBarcode(id, n, params)
            })
        },
    }
}
export default registerMixin